/* istanbul ignore file */
import React from 'react';
import { Box } from '@mui/material';

const EmployeeContractEndDateLayout = ({
  dateField,
  notification,
}: {
  dateField?: React.ReactNode;
  notification?: React.ReactNode;
}) => {
  return (
    <Box data-testid="employee-contract-end-date-layout" display="flex" alignItems="center">
      {dateField}
      {notification}
    </Box>
  );
};

export default EmployeeContractEndDateLayout;
